import styled from "styled-components";
import { HXButton } from "../HXButton";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { FlexRowDiv } from "../common.styles";
export const DocumentRetrievalViewParent = styled.div ``;
export const SearchSection = styled.div `
    margin-bottom: 24px;
    padding: 16px;
    background-color: ${colors.black_4};
    border-radius: 8px;
`;
export const SearchRow = styled(FlexRowDiv) `
    gap: 12px;
    align-items: center;
`;
export const SearchInput = styled.input `
    flex: 1;
    padding: 10px 14px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-size: ${fontSizes.STANDARD};

    &:focus {
        outline: none;
        border-color: ${colors.blue_main};
    }
`;
export const SummaryStats = styled(FlexRowDiv) `
    gap: 24px;
    margin-bottom: 24px;
    padding: 16px;
    background-color: ${colors.black_4};
    border-radius: 8px;
`;
export const StatItem = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 100px;
`;
export const StatValue = styled.div `
    font-size: 28px;
    font-weight: 600;
`;
export const StatLabel = styled.div `
    font-size: 12px;
    color: ${colors.black_lighter};
    text-transform: uppercase;
`;
export const Section = styled.div `
    width: 100%;
    max-width: 1400px;
    margin-bottom: 30px;
`;
export const SectionHeader = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
    margin-bottom: 12px;
`;
export const PatientDetailsCard = styled.div `
    background-color: white;
    border: 1px solid ${colors.black_30};
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
`;
export const StatusGrid = styled.div `
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
`;
export const StatusCard = styled.div `
    padding: 16px;
    background-color: ${colors.black_4};
    border-radius: 6px;
    border-left: 4px solid
        ${(props) => {
    switch (props.variant) {
        case "success":
            return "#4CAF50";
        case "warning":
            return "#FF9800";
        case "error":
            return colors.tulip_main;
        case "info":
            return colors.blue_main;
        case "secondary":
        default:
            return colors.black_30;
    }
}};
`;
export const StatusLabel = styled.div `
    font-size: 12px;
    color: ${colors.black_lighter};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
`;
export const StatusValue = styled.div `
    font-size: 18px;
    font-weight: 600;
`;
export const Badge = styled.span `
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    background-color: ${(props) => {
    switch (props.variant) {
        case "success":
            return "#E8F5E9";
        case "warning":
            return "#FFF3E0";
        case "error":
            return "#FFEBEE";
        case "info":
            return "#E3F2FD";
        default:
            return colors.black_8;
    }
}};
    color: ${(props) => {
    switch (props.variant) {
        case "success":
            return "#2E7D32";
        case "warning":
            return "#E65100";
        case "error":
            return "#C62828";
        case "info":
            return "#1565C0";
        default:
            return colors.black_main;
    }
}};
`;
export const TableWrapper = styled.div `
    width: 100%;
    overflow-x: auto;
    margin-top: 8px;
`;
export const DataTable = styled.table `
    font-size: ${fontSizes.SMALL};
    width: 100%;
    min-width: 100%;
    border: 1px solid ${colors.black_30};
    border-collapse: collapse;

    & th {
        text-align: left;
        font-weight: 600;
        background-color: ${colors.black_4};
        white-space: nowrap;
    }

    & th,
    td {
        padding: 10px 12px;
        vertical-align: middle;
        border-bottom: 1px solid ${colors.black_8};
    }

    & tbody tr:hover {
        background-color: ${colors.black_4};
    }
`;
export const DetailsSection = styled.div `
    margin-top: 20px;
`;
export const DetailsSectionTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: 600;
    margin-bottom: 8px;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        color: ${colors.blue_main};
    }
`;
export const DetailsContent = styled.div `
    display: ${(props) => (props.visible ? "block" : "none")};
`;
export const ActionButtons = styled(FlexRowDiv) `
    gap: 12px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid ${colors.black_8};
`;
export const RefreshButton = styled(HXButton) `
    margin-left: auto;
`;
export const ErrorMessage = styled.div `
    background-color: #ffebee;
    color: #c62828;
    padding: 12px 16px;
    border-radius: 6px;
    margin-top: 12px;
`;
export const SuccessMessage = styled.div `
    background-color: #e8f5e9;
    color: #2e7d32;
    padding: 12px 16px;
    border-radius: 6px;
    margin-top: 12px;
`;
export const CodeText = styled.code `
    background-color: ${colors.black_8};
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
`;
export const EmptyState = styled.div `
    text-align: center;
    padding: 40px;
    color: ${colors.black_lighter};
    font-size: 14px;
`;
export const DetailRow = styled.tr ``;
export const DetailLabel = styled.th `
    width: 180px;
`;
export const DetailValue = styled.td ``;
export const BatchHeaderRow = styled.div `
    display: grid;
    grid-template-columns: 24px 1fr 120px 300px;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    user-select: none;
    padding: 4px 0;

    &:hover {
        color: ${colors.blue_main};
    }
`;
export const BatchId = styled.span `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const BatchStatus = styled.span `
    text-align: center;
`;
export const BatchInfo = styled.span `
    font-size: 12px;
    color: ${colors.black_lighter};
    text-align: right;
`;
